import React, { useMemo } from 'react';
import Link from 'next/link';

import { ILogoImages } from '../models/logo';
import filterTeams from '../utils/filterHistoricalTeams';

interface IProps {
	logoImages: ILogoImages[] | null;
}

export default function LogoRow({ logoImages }: IProps) {
	const mappedLogos = useMemo(
		() => {
			if (!logoImages) return [];
			const logoTeams = logoImages
				.map((logo) => ({
					id: Number(logo.id),
					title: logo.title,
					slug: logo.slug,
					team_logo: logo.team_logo,
				}))
				.filter(team => !isNaN(team.id));
			return filterTeams(logoTeams).filter(team => team.team_logo);
		},
		[logoImages],
	);

	return (
		<div className="w-full bg-white">
			<div className="container mx-auto px-5 hidden lg:flex flex-row justify-between items-center bg-white">
				{mappedLogos?.map((logo) => (
					<div key={logo.id} className="flex flex-col justify-center items-center m-3">
						<Link href={`/teams/${logo.slug}`}>
							<img
								src={logo.team_logo}
								className="w-10 h-10 object-contain transition-opacity hover:opacity-75"
								alt={logo.title.rendered}
							/>
						</Link>
					</div>
				))}
			</div>
		</div>
	);
}
